// This is only intended for use in the Quote Page Store
import type { Reducer } from "redux";
import "redux";

type Action = { readonly type: string; readonly payload: any };

const REPLACE_STATE = "REPLACE_STATE";

export const replaceState = <S>(newState: S) => ({
  type: REPLACE_STATE,
  payload: newState,
});

export const allowReplacement =
  <S, A extends Action>(baseReducer: Reducer<S, A>) =>
  (s: S, a: A): S => {
    if (a.type === REPLACE_STATE) {
      const abTests = { ...s.abTests, ...a.payload.abTests };
      const companyProfile = {
        ...s.companyProfile,
        ...a.payload.companyProfile,
      };

      return baseReducer(
        {
          ...s,
          ...a.payload,
          ...{ abTests },
          ...{ companyProfile },
        },

        a,
      );
    }
    return baseReducer(s, a);
  };
